import Api from '@/services/Api'

export default {
    getAllTipoTasas(){
        return Api().get('tipoTasa/getAll')
    },
    getTipoTasaById(id){
        return Api().get('tipoTasa/tipoTasaById/'+id)
    },
    createTipoTasa(datos){
        return Api().post('tipoTasa/create',datos)
    },
    updateTipoTasaById(datos){
        return Api().put('tipoTasa/update',datos)
    },
    deleteTipoTasa(id){
        return Api().delete('tipoTasa/delete/'+id)
    },
    leaTasasZScore(){
        return Api().get('tipoTasa/leaTasasZScore')
    }
}
